// extracted by mini-css-extract-plugin
export var errorIcon = "_md-1";
export var nameLogo = "_md-0";